<template>
  <div class="container">
    <div class="login-box" @keydown.enter="submit">
      <div class="title">LAOT</div>
      <div class="body">
        <div class="line">
          <div class="label">用户名/手机号</div>
          <a-input v-model:value="data.username" placeholder="请输入用户名/手机号" />
        </div>
        <div class="line">
          <div class="label">密码</div>
          <a-input-password
            v-model:value="data.password"
            placeholder="请输入密码"
          />
        </div>
        <div style="display: flex; flex-direction: row" v-if="needCaptcha">
          <vue-hcaptcha
            ref="captcha"
            @verify="onVerify"
            :sitekey="config.captchaKey"
          ></vue-hcaptcha>
        </div>
      </div>
      <div class="btn-group">
        <div>
          <sc-btn type="primary" :handler="submit" text="登录" />
          <sc-btn
            style="margin-left: 10px"
            :disabled="!form.canReset.value"
            :handler="form.reset"
            text="重置"
          />
        </div>
        <div
          style="display: flex; flex-direction: row; justify-content: flex-end"
        >
          <sc-btn
            type="link"
            text="注册账号"
            :handler="() => router.push('/register')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ScForm } from '@/models/ScForm';
import { useRouter } from 'vue-router';
import { tokenManager } from '@/util/token';
import { request } from '@/util/request';
import { user } from '@/models/User';
import { addBizRouter } from '@/router';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import VueHcaptcha from '@hcaptcha/vue3-hcaptcha';
import config from '@/config';
import { message } from 'ant-design-vue';
import { ref } from 'vue';

const form = new ScForm();
const captcha = ref<InstanceType<typeof VueHcaptcha>>();
form.init();
const router = useRouter();
const data = form.data;
const needCaptcha = ref(false);

async function onVerify(token: string) {
  data.value.code = token;
}

async function submit() {
  if (needCaptcha.value && !data.value.code) {
    message.error('请先完成验证');
    return;
  }
  const redirect = router.currentRoute.value.query?.redirect;
  const url = typeof redirect === 'string' ? redirect : '/';
  const res = await request('/management/login/login', form.data.value, {
    noNeedLogin: true,
    onError: (err) => {
      if (err.type === 'biz') {
        captcha.value?.reset();
      }
    },
  });
  if (res) {
    tokenManager.set(res.token);
    user.set(res.user);
    await addBizRouter();
    await router.replace(url);
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-image: url('@/assets/images/bg.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;

  .login-box {
    width: 500px;
    background: #ffffffef;
    margin: 0 auto;
    //height: 300px;

    .title {
      padding: 20px;
      font-size: $font-size-large;
      font-weight: $font-weight-primary;
      border-bottom: 1px solid $color-content-border;
    }

    .body {
      padding: 40px 20px 20px;
    }

    .line {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 20px;
      padding-right: 20px;

      .label {
        width: 130px;
      }
    }

    .btn-group {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      border-top: 1px solid $color-content-border;
      padding: $spacing-medium;
    }
  }
}
</style>
